<template>
  <div class="customer-detail">
    <div class="breadcrumb">
      <i class="el-icon-arrow-left"></i>
      <el-breadcrumb separator="/">
        <el-breadcrumb-item>客户管理</el-breadcrumb-item>
        <el-breadcrumb-item>客户详情</el-breadcrumb-item>
        <el-breadcrumb-item>财务录入</el-breadcrumb-item>
      </el-breadcrumb>
    </div>
    <div class="line"></div>
    <div class="content">
      <div class="back">
        <span
          @click="goBack"
          style="color: #333333;font-size: 18px;margin-left: 30px;"
          >返回</span
        >
      </div>
      <div class="form">
        <p class="tip">基础信息</p>
        <el-form :form="form" label-width="150px" :disabled="true">
          <el-form-item label="当前企业：">
            <el-input class="" v-model="form.epName"></el-input>
          </el-form-item>

          <el-form-item label="账号：">
            <el-input v-model="form.email"></el-input>
          </el-form-item>

          <el-form-item label="机构ID：">
            <el-input v-model="form.epId"></el-input>
          </el-form-item>

          <el-form-item label="当前财务管理员：">
            <el-input v-model="form.representative"></el-input>
          </el-form-item>

          <el-form-item label="客户渠道：" prop="resource">
            <el-radio-group v-model="channel">
              <el-radio :label="2">官网客户</el-radio>
              <el-radio :label="1">腾讯内部客户</el-radio>
            </el-radio-group>
          </el-form-item>
        </el-form>
      </div>
      <div class="form">
        <p class="tip">财务信息</p>
        <template v-if="channel == 2">
          <el-form
            :form="gwform"
            :model="gwform"
            status-icon
            :rules="gwformrules"
            ref="gwform"
            label-width="150px"
          >
            <el-form-item class="upload-paper" label="上传汇款单：">
              <div class="wrap">
                <!-- <span class="btn"><i class="icon icon-shang-chuan"></i>上传文件</span > -->
                <el-upload
                  class="upload-file"
                  drag
                  :multiple="false"
                  :headers="uploadHeaders"
                  :show-file-list="false"
                  :on-error="handleAvatarError1"
                  :on-success="handleAvatarSuccess1"
                  :before-remove="beforeRemove1"
                  :file-list="fileList"
                  :before-upload="beforeAvatarUpload1"
                  action="/api/ump/admin/ep/finance/order/remit/receipt"
                >
                 <div v-if="imageUrl" style="width: 360px;height: 180px;display: flex;
                      justify-content: center;
                      align-items: center;">
                  <img
                   :src="imageUrl"
                    class="avatar"
                    id="embed"
                  />
                 </div>
                  <pdf v-else-if="pdfUrl" :src="pdfUrl" ref="pdf"> </pdf>
                  <div v-else>
                    <i class="el-icon-upload"></i>
                    <div class="el-upload__text">
                      <div>将文件拖拽到此处,或<em>点击上传</em></div>
                      <div class="el-upload__tip" slot="tip">
                        只能扩展名:jpg,png文件，且大小不超过5M
                      </div>
                    </div>
                  </div>
                </el-upload>
                <ul
                  class="el-upload-list el-upload-list--text"
                  v-if="imageUrl || pdfUrl"
                >
                  <li tabindex="0" class="el-upload-list__item is-success">
                    <!---->
                    <a class="el-upload-list__item-name"
                      ><i class="el-icon-document"></i> {{ this.tempImg.name }}
                    </a>
                    <label class="el-upload-list__item-status-label">
                      <i
                        class="el-icon-upload-success el-icon-circle-check"
                      ></i> </label
                    ><i @click="beforeRemove1" class="el-icon-close"></i
                    ><i class="el-icon-close-tip">按 delete 键可删除</i
                    ><!----><!---->
                  </li>
                </ul>
              </div>
            </el-form-item>
            <el-form-item label="到账金额(元)：" prop="remitAmount">
              <el-input v-model.trim="gwform.remitAmount"></el-input>
            </el-form-item>
            <el-form-item label="汇款账号：" prop="remitAccount">
              <el-input v-model.trim="gwform.remitAccount"></el-input>
            </el-form-item>
            <el-form-item label="汇款银行：" prop="remitBankName">
              <el-input v-model.trim="gwform.remitBankName"></el-input>
            </el-form-item>
            <el-form-item label="银行流水单号：" prop="remitBankSerialNo">
              <el-input v-model.trim="gwform.remitBankSerialNo"></el-input>
            </el-form-item>

            <el-form-item label="备注(可选)：" prop="memo">
              <el-input
                type="textarea"
                class="text-info"
                v-model.trim="gwform.memo"
              ></el-input>
            </el-form-item>
            <el-form-item>
              <div class="btns">
                <el-button @click="saveDraftTwo" class="refuse"
                  >保存草稿</el-button
                >
                <el-button
                  @click="adoptClick('gwform')"
                  type="primary"
                  class="adopt"
                  >提交</el-button
                >
              </div>
            </el-form-item>
          </el-form>
        </template>
        <template v-if="channel == 1">
          <el-form
            :form="txform"
            status-icon
            ref="txform"
            :model="txform"
            label-width="150px"
            :rules="txrules"
          >
            <el-form-item label="业务种类：">
              <div style="">
                <div class="species">
                  <div
                    class="item"
                    @click="changeDetailTypeOption(index + 1)"
                    v-for="(item, index) in DetailTypeOptions"
                    :key="index"
                    :class="[index + 1 == curDetailTypeOption ? 'active' : '']"
                  >
                    {{ item.label }}
                    <div class="right-arrow"></div>
                  </div>
                </div>
              </div>
            </el-form-item>
            <el-form-item label="业务单价(元)：" prop="packageUnit">
              <el-input v-model="txform.packageUnit"></el-input>
            </el-form-item>

            <el-form-item label="结算周期：" prop="packageCycle">
              <el-select
                class="js-time"
                v-model="txform.packageCycle"
                placeholder="请选择"
              >
                <el-option label="1个月" value="1"></el-option>
                <el-option label="3个月" value="3"></el-option>
                <el-option label="6个月" value="6"></el-option>
                <el-option label="12个月" value="12"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item>
              <div class="btns">
                <el-button @click="saveDraft" class="refuse"
                  >保存草稿</el-button
                >
                <el-button
                  @click="adoptFinalClick('txform')"
                  type="primary"
                  class="adopt"
                  >提交</el-button
                >
              </div>
            </el-form-item>
          </el-form>
        </template>
      </div>
    </div>
  </div>
</template>

<script>
import Api from '@/api'
import { statusCode, codeInfo } from '@/config'
import pdf from 'vue-pdf'
import {
  setStorageItem,
  getStorageItem,
  removeStorageItem,
  getCookie,
  delCookie,
} from '@/utils'

export default {
  name: 'CustomerDetail',
  components: { pdf },
  data() {
    const validatePrice = (rule, value, callback) => {
      const reg = /^[0-9][0-9]*([.][0-9]{0,2})?$/
      const maxLen = 30
      // if (value == 0) {
      //   return callback(new Error('请输入大于0的数字'))
      // }
      if (!value) {
        return callback(new Error('业务单价不能为空'))
      }
      if (reg.test(value) && value.length < maxLen) {
        return callback()
      }
      return callback(new Error('输入有误，输入长度限定为1-30位纯数字，保留两位小数'))
    }
    const validateMoney = (rule, value, callback) => {
      const reg = /^(0|[1-9][0-9]*)(\.\d+)?$/
      if (!value) {
        return callback(new Error('不能为空'))
      }
      if (value == 0) {
        return callback(new Error('请输入大于0的数字'))
      }
      // if (!Number.isInteger(value)) {
      //   callback(new Error('请输入数字值'))
      // } else {
      if (!reg.test(value)) {
        callback('只能输入正数，不能包含字母，下划线等非法字符')
      }
      if (Number(value) > 1000000000) {
        return callback('输入金额超出最大限制10亿')
      }
      if (value.length > 100) {
        callback(new Error('输入有误，输入长度限定为1-100位数字'))
      } else {
        callback()
      }
    }
    const validateAccount = (rule, value, callback) => {
      const reg = /^(0|[1-9][0-9]*)$/
      if (!value) {
        return callback(new Error('不能为空'))
      }
      if (value == 0) {
        return callback(new Error('请输入大于0的数字'))
      }
      // if (!Number.isInteger(value)) {
      //   callback(new Error('请输入数字值'))
      // } else {
      if (!reg.test(value)) {
        callback('只能输入正数，不能包含字母，下划线等非法字符')
      }
      if (value.length > 100) {
        returncallback(new Error('输入有误，输入长度限定为1-100位数字'))
      } else {
        callback()
      }
    }

    const validateBankName = (rule, value, callback) => {
      const reg = /[^\u4E00-\u9FA5]{1,}/
      if (!value) {
        return callback(new Error('不能为空'))
      }
      if (reg.test(value)) {
        callback('只能中文字符')
      }
      if (value.length > 50) {
        callback(new Error('输入有误，输入长度限定为1-50个字符'))
      } else {
        callback()
      }
    }

    const validateBankSerialNo = (rule, value, callback) => {
      // const reg = /^(0|[1-9][0-9]*)(\.\d+)?$/
      const reg = /^(0|[1-9][0-9]*)$/
      if (!value) {
        return callback(new Error('不能为空'))
      }
      if (!reg.test(value)) {
        return callback('只能是数字，不能包含字母，下划线等非法字符')
      }
      if (value.length > 100) {
        callback(new Error('输入有误，输入长度限定为1-100个字符'))
      } else {
        callback()
      }
    }
    return {
      pdfUrl: '', // pdf
      imageUrl: '', // 图片路径
      currentPage: 0, // pdf文件页码
      pageCount: 0, // pdf文件总页数
      curDetailTypeOption: 1,
      fileList: [],
      DetailTypeOptions: [
        {
          value: '1',
          label: '⽹页取证',
        },
        {
          value: '2',
          label: 'HASH存证',
        },
        // {
        //   value: '3',
        //   label: '区块链合同',
        // },
        // {
        //   value: '4',
        //   label: '版权认证',
        // },
        // {
        //   value: '5',
        //   label: ' 在线公证',
        // },
      ],
      remitFileId: '', // 汇款单id
      uploadHeaders: {},
      //  channel: 1, //  0客户未定，保留留以前模式， 2官⽹网客户， 1腾讯内部
      form: {},
      txform: {
        packageCycle: '', // 结算周期
        packageUnit: '', // 单价
      },
      gwform: {
        remitAmount: '',
        remitAccount: '',
        remitBankSerialNo: '',
        remitBankName: '',
        memo: '',
      },
      gwformrules: {
        remitAmount: [
          { validator: validateMoney, trigger: 'blur', required: true },
        ],
        remitAccount: [
          { validator: validateAccount, trigger: 'blur', required: true },
        ],
        remitBankName: [
          { validator: validateBankName, trigger: 'blur', required: true },
        ],
        remitBankSerialNo: [
          { validator: validateBankSerialNo, trigger: 'blur', required: true },
        ],
      },
      txrules: {
        packageUnit: [
          {
            validator: validatePrice,
            trigger: 'blur',
            type: 'number',
            required: true,
          },
        ],
        packageCycle: [
          { required: true, message: '请选择结算周期', trigger: 'change' },
        ],
      },
    }
  },
  computed: {
    channel() {
      return parseInt(getStorageItem('epDetail').customerChannel)
    },
  },
  created() {
    // this.pdfUrl = pdf.createLoadingTask(this.pdfUrl)
    this.form = getStorageItem('epDetail')
    // this.channel = parseInt(getStorageItem('epDetail').customerChannel)
    switch (this.form.state) {
      case 1:
        this.status = '待审核'
        break
      case 2:
        this.status = '已通过'
        break
      case 3:
        this.status = '未通过'
        break
      default:
        this.status = ''
    }
  },
  mounted() {
    this.uploadHeaders['X-XSRF-TOKEN'] = getCookie('zxadmintoken')
      ? decodeURIComponent(getCookie('zxadmintoken'))
      : ''
    const epDetail = JSON.parse(localStorage.getItem('epDetail'))
    console.log('epDetail', epDetail)
    if (localStorage.getItem(`txFinancialSave${epDetail.epId}`) != null) {
      const data = JSON.parse(localStorage.getItem(`txFinancialSave${epDetail.epId}`))
      this.curDetailTypeOption = data.curDetailTypeOption
      this.txform.packageCycle = data.packageCycle
      this.txform.packageUnit = data.packageUnit
    }

    if (localStorage.getItem(`txFinancialSaveTwo${epDetail.epId}`) != null) {
      const data = JSON.parse(localStorage.getItem(`txFinancialSaveTwo${epDetail.epId}`))
      this.gwform.remitAmount = data.remitAmount
      this.gwform.remitAccount = data.remitAccount
      this.gwform.remitBankSerialNo = data.remitBankSerialNo
      this.gwform.remitBankName = data.remitBankName
      this.gwform.memo = data.memo
    }
  },
  methods: {
    beforeAvatarUpload1(file) {
      console.log('beforeAvatarUpload1', file)
      this.tempImg = file
      this.$message.closeAll()
      const isJPG = file.type
      if (
        isJPG != 'image/png' &&
        isJPG != 'image/jpeg'
      ) {
        this.$message.error('上传仅支持PNG、JPG、JPGE格式!')
        return false
      } else if (file.size >= 5242880) {
        this.$message.error('图片大小不能超过5M')
        return false
      }
      this.backLoading = true
    },
    beforeRemove1(file, fileList) {
      this.imageUrl = ''
      this.pdfUrl = ''
      this.remitFileId = ''
    },
    viewImg() {},
    handleAvatarError1(err, file, fileList) {
      if (err && err.message && JSON.parse(err.message).retCode == '7011') {
        const message = '用户身份认证失败，请重新登录'
        const duration = 2000
        this.$message({
          message,
          duration,
          type: 'error',
        })
        if (location.href.includes(window.managment_redirectUrl.admin)) {
          // 测试环境
          // delCookie('zxadmintoken', '.zhixinblockchain.com')
          delCookie('zxadmintoken', window.location.host)
        } else {
          // 本地
          delCookie('zxadmintoken') // 兼容本地调试
        }
        localStorage.removeItem('zxadmintoken')
        this.$router.push({
          path: '/login',
        })
      }
    },
    handleAvatarSuccess1(res, file) {
      console.log('handleAvatarSuccess1', res, file)
      // 判断文件的后缀名
      if (file.name.includes('.pdf')) { // pdf
        // this.pdfUrl = URL.createObjectURL(file.raw)
        this.imageUrl = ''
        this.pdfUrl = URL.createObjectURL(file.raw)
      } else {
        this.pdfUrl = ''
        this.imageUrl = URL.createObjectURL(file.raw)
      }
      this.remitFileId = res.remitFileId
      if (res.id) {
      } else {
        for (const key in codeInfo) {
          if (key == res.retCode) {
            const message = '上传失败，重新上传'
            const duration = 2000
            this.$message({
              message,
              duration,
              type: 'error',
            })
            this.imageUrl = ''
            this.remitFileId = ''
          }
        }
      }
    },
    goBack() {
      this.$router.go(-1)
    },
    // 单选的切换
    changeDetailTypeOption(index) {
      this.curDetailTypeOption = index
    },
    // 财务信息保存
    adoptFinalClick(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          const params = JSON.parse(JSON.stringify(this.txform))
          params.epId = getStorageItem('epDetail').epId
          params.busiDetailType = this.curDetailTypeOption
          params.busiCategory = this.curDetailTypeOption
          params.packageCycle = parseInt(params.packageCycle)
          params.packageUnit = parseFloat(params.packageUnit)
          console.log('params', params)

          Api.customer.bookkeepOrder(params).then((res) => {
            if (res.retCode === statusCode.SUCCESS) {
              this.$message({
                showClose: true,
                message: '财务录入成功',
                type: 'success',
              })
              this.$router.go(-1)
            } else {
              this.$message.closeAll()
              this.$message({
                showClose: true,
                message: res.retMsg,
                type: 'error',
              })
            }
          })
        } else {
          console.log('error submit!!')
          return false
        }
      })
    },
    // 内部记账保存
    adoptClick(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          if (!this.remitFileId) {
            this.$message({
              showClose: true,
              message: '请上传汇款单',
              type: 'warning',
            })
            return
          }
          const params = JSON.parse(JSON.stringify(this.gwform))
          params.epId = getStorageItem('epDetail').epId
          params.remitFileId = this.remitFileId
          params.remitAccount = params.remitAccount.toString()
          params.remitAmount = Number(params.remitAmount)
          Api.customer.remitFinanceOrder(params).then((res) => {
            if (res.retCode === statusCode.SUCCESS) {
              this.$message({
                showClose: true,
                message: '财务录入成功',
                type: 'success',
              })
              this.$router.go(-1)
            } else {
              this.$message.closeAll()
              this.$message({
                showClose: true,
                message: res.retMsg,
                type: 'error',
              })
            }
          })
        } else {
          console.log('error submit!!')
          return false
        }
      })
    },
    // 保存草稿功能
    saveDraftTwo() {
      const epDetail = JSON.parse(localStorage.getItem('epDetail'))
      console.log('epDetail123', epDetail)
      const data = {
        remitAmount: Number(this.gwform.remitAmount),
        remitAccount: this.gwform.remitAccount,
        remitBankSerialNo: this.gwform.remitBankSerialNo,
        remitBankName: this.gwform.remitBankName,
        memo: this.gwform.memo,
      }
      const p1 = new Promise((res, rej) => {
        localStorage.setItem(
          `txFinancialSaveTwo${epDetail.epId}`,
          JSON.stringify(data)
        )
        res()
      })
      p1.then(() => {
        this.$message.success('保存草稿成功')
      })
    },
    // 保存草稿功能
    saveDraft() {
      const epDetail = JSON.parse(localStorage.getItem('epDetail'))
      const data = {
        packageCycle: this.txform.packageCycle,
        packageUnit: this.txform.packageUnit,
        curDetailTypeOption: this.curDetailTypeOption,
      }

      const p1 = new Promise((res, rej) => {
        localStorage.setItem(
          `txFinancialSave${epDetail.epId}`,
          JSON.stringify(data)
        )
        res()
      })
      p1.then(() => {
        this.$message.success('保存草稿成功')
      })
    },
  },
}
</script>
<style lang="scss" scoped>
.customer-detail {
  background-color: #fff;
  width: 100%;
  .line {
    width: 100%;
    height: 10px;
    background-color: #f7f7f7;
  }
  .breadcrumb {
    display: flex;
    height: 50px;
    background-color: #ffffff;
    line-height: 50px;
    padding-left: 15px;
    i {
      line-height: 50px;
      margin-left: 15px;
    }
    .el-breadcrumb {
      line-height: 50px;
    }
  }
  .content {
    background-color: #ffffff;
    .back {
      height: 60px;
      margin-top: 10px;
      background-color: #ffffff;
      border-bottom: 1px solid #eeeeee;
      display: flex;
      justify-content: space-between;
      span {
        margin-right: 40px;
        line-height: 60px;
        color: #0034b3;
        cursor: pointer;
      }
    }
    .form {
      display: flex;
      flex-wrap: wrap;
      justify-content: center;
      .tip {
        margin-top: 40px;
        margin-left: 60px;
        color: #333333;
        position: relative;
        padding-left: 10px;
        width: calc(100% - 100px);
      }
      .tip::before {
        height: 16px;
        background-color: #2455ce;
        position: absolute;
        content: '';
        width: 4px;
        left: 0;
        top: 3px;
      }
      .species {
        display: flex;
        position: absolute;
        width: 540px;
        .item {
          cursor: pointer;
          text-align: center;
          background: white;
          border: 1px solid #e6e6e6;
          border-radius: 4px;
          font-size: 14px;
          font-family: PingFang SC;
          font-weight: 500;
          color: #333333;
          padding: 0px 14px;
          line-height: 32px;
          height: 32px;
          cursor: pointer;
          margin-right: 12px;
          position: relative;
        }
        .active {
          border: 1px solid #2f5ab2;
          .right-arrow {
            width: 0;
            height: 0;
            border-width: 11px;
            border-style: solid;
            border-color: #2f5ab2 #2f5ab2 transparent transparent;
            position: absolute;
            top: 0px;
            right: 0px;
          }
          .right-arrow::before {
            content: '\2714';
            color: #fff;
            display: inline-block;
            position: absolute;
            top: -19px;
            left: 1px;
            font-size: 3px;
          }
        }
      }
      .el-form {
        margin-top: 30px;
        margin-left: -150px;
        .el-form-item {
          /deep/ .el-input.is-disabled .el-input__inner {
            color: #696d75;
          }
          .el-input {
            width: 380px;
          }
          .busiLincese,
          .officialLetter {
            position: relative;
          }
          .click-box {
            width: 100px;
            height: 120px;
            position: absolute;
            overflow: hidden;
            top: 0;
            cursor: pointer;
          }
          .img-box {
            width: 100px;
            height: 120px;
            overflow: hidden;
          }
          img {
            width: 360px;
            cursor: pointer;
          }
        }
        .js-time {
          width: 380px;
        }
      }
      .btns {
        width: 100%;
        text-align: center;
        .refuse {
          color: #0034b3;
          border-color: #0034b3;
          width: 150px;
          height: 50px;
          margin-right: 60px;
        }
        .adopt {
          width: 150px;
          height: 50px;
          background-color: #1d60c0;
        }
        margin-bottom: 50px;
      }
    }
  }
  .el-dialog__wrapper {
    text-align: center;
    img {
      width: 100%;
    }
    .dialog-footer {
      margin-top: -20px;
      text-align: center;
      .el-button {
        width: 134px;
      }
    }
    /deep/ .el-dialog__footer {
      text-align: center;
    }
  }
}
.upload-paper {
  // display:flex;position: relative;
  // height: 300px;
  .label {
    width: 150px;
    display: inline-block;
    text-align: right;
    padding-right: 12px;
    box-sizing: border-box;
    color: #606266;
  }
  .wrap {
    // position:absolute;top:10px;left:155px;
    .btn {
      border: 1px solid #002379;
      padding: 3px 8px;
      color: #002379;
      font-size: 16px;
      cursor: pointer;
      border-radius: 3px;
      .icon {
        color: #1d60c0;
      }
    }
    .upload-demo {
      margin-top: 10px;
    }
  }
}
.upload-file {
  margin-top: 10px;
  ::v-deep .el-upload__tip {
    height: 12px;
    line-height: 12px;
    margin-top: 0px;
  }
}
</style>
